var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-2"},[_c('CoHeadline',{staticClass:"mb-4 mx-2",attrs:{"level":2}},[_vm._v(" "+_vm._s(_vm.$t('labels.download'))+" ")]),_c('CoFile',{ref:"coFileRef",attrs:{"file":_vm.file,"mode":"display"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }